import React, { createContext, useContext, useState, ReactNode } from 'react';

type ChatMode = 'minimized' | 'normal' | 'fullscreen';

interface ChatContextType {
  chatMode: ChatMode;
  setChatMode: (mode: ChatMode) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const ChatProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [chatMode, setChatMode] = useState<ChatMode>('minimized');

  return (
    <ChatContext.Provider value={{ chatMode, setChatMode }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};